import { render, staticRenderFns } from "./TronExtention.vue?vue&type=template&id=7ec814c1&scoped=true"
import script from "./TronExtention.vue?vue&type=script&lang=js"
export * from "./TronExtention.vue?vue&type=script&lang=js"
import style0 from "./TronExtention.vue?vue&type=style&index=0&id=7ec814c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec814c1",
  null
  
)

export default component.exports